import { RowSelectedEvent } from '@ag-grid-community/core';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { ModalService } from '@app/core/services/modal.service';
import { OrderHeadGet, OrderheadService, PosGridRow } from '@app/services/orderhead.service';

@Component({
    selector: 'tt-order-head-production',
    templateUrl: './order-head-production.component.html',
    styleUrls: ['./order-head-production.component.css'],
})
export class OrderHeadProductionComponent implements OnChanges {
    @Input()
    public get?: OrderHeadGet;

    public posGrid?: GridOptions<PosGridRow>;

    public poPowStatusGrid?: GridOptions;

    public powStatusGrid?: GridOptions;

    public olmGrid?: GridOptions;

    public poKeyno?: string | number;

    constructor(
        private orderhead: OrderheadService,
        private modal: ModalService,
    ) {}

    public onTabChanged() {
        if (!this.get) return;

        if (this.get.gb_orderhead_main_production_sub === 'POS') {
            this.readPosGrid();

            if (!!this.poKeyno) {
                this.readPoPowStatusGrid();
            }
        } else if (this.get.gb_orderhead_main_production_sub === 'POW') {
            this.readPowStatusGrid();
        } else if (this.get.gb_orderhead_main_production_sub === 'OLM') {
            this.readOlmGrid();
        }
    }

    public onPoSelected(event: RowSelectedEvent) {
        if (event.node.isSelected()) {
            this.poKeyno = event.data.po_keyno;
            this.readPoPowStatusGrid();
        }
    }

    public finishPosNow = async () => {
        if (!this.get || !this.posGrid?.gridfunc) return;

        const rows = this.posGrid.gridfunc.getAllRows().filter((row) => +row['quantity_finish_now'] > 0);

        if (rows.length === 0) return;

        let value = 0;

        const progressDialog = this.modal.openProgressDialog({ max: rows.length, value, rememberId: 'w_orderhead.posgrid.progress', label: '', disableClose: true });

        for (let row of rows) {
            try {
                await progressDialog.setLabel(`ID: ${row.po_keyno}`, false);

                const { errorcode, errormessage } = await this.orderhead.setProductionOrderAsFinished(row);

                if ('' + errorcode !== '0') {
                    progressDialog.updateInvalidText(`ID: ${row.po_keyno}\n${errormessage}`);
                    progressDialog.updateStatus('invalid');
                    break;
                } else {
                    value = value + 1;
                    progressDialog.updateValue(value);
                }
            } catch (error) {
                console.error(error);
                progressDialog.updateStatus('invalid');
                progressDialog.dialogRef.disableClose = false;
                break;
            }
        }

        if (value === rows.length) {
            progressDialog.updateStatus('finish');
        }

        this.readPosGrid();

        if (!!this.poKeyno) {
            this.readPoPowStatusGrid();
        }
    };

    public readPosGrid() {
        if (!this.posGrid) {
            this.posGrid = new Grid<PosGridRow>()
                .setRememberId('w_orderhead_pos_grid_list')
                .setLoadDataFunction({ method: 3622, parameters: () => ({ order_internal_no: this.get?.order_internal_no }) })
                .addToolbarButton({ name: 'finish_po_now', text: 'finish_po_now', translate: true, icon: 'fas fa-check', cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r', spinOnAction: true, func: this.finishPosNow });
        } else {
            this.posGrid.gridfunc?.read();
        }
    }

    public readPoPowStatusGrid() {
        if (!this.poPowStatusGrid) {
            this.poPowStatusGrid = new Grid().setRememberId('w_pow_status_grid').setLoadDataFunction({ method: 3665, parameters: () => ({ argtype: 'po_keyno', argvalue: this.poKeyno }) });
        } else {
            this.poPowStatusGrid.gridfunc?.read();
        }
    }

    public readPowStatusGrid() {
        if (!this.powStatusGrid) {
            this.powStatusGrid = new Grid().setRememberId('pow_status_grid_order_internal_no').setLoadDataFunction({ method: 3665, parameters: () => ({ argtype: 'order_internal_no', argvalue: this.get?.order_internal_no }) });
        } else {
            this.powStatusGrid.gridfunc?.read();
        }
    }

    public readOlmGrid() {
        if (!this.olmGrid) {
            this.olmGrid = new Grid().setRememberId('w_orderhead_olm_grid').setLoadDataFunction({ method: 4022, parameters: () => ({ order_internal_no: this.get?.order_internal_no }) });
        } else {
            this.olmGrid.gridfunc?.read();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['get']) {
            this.onTabChanged();
        }
    }
}
